export default __webpack_public_path__ + "static/media/haust-logo.7407e978.svg";